export default{
    setActiveMiniPlayer(state, payload){
        state.currentMiniPlayer = payload;
    }
}